import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { isNil } from 'ramda'
import { breakpoints } from '@/styles'
import { ValueText } from '@/features/Application/elements'
import StatusBadge from '@/components/status-badge'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

const SubWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  @media only screen and (max-width: ${breakpoints.tabletLandscape}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

const SummaryContainer = ({ hasWarning, value, rate, isLocked }) => {
  const { t } = useTranslation()
  const titles = {
    poor: t('l.application.view.poor.text', 'Poor'),
    average: t('l.application.view.average.text', 'Average'),
    very_good: t('l.application.view.very_good.text', 'Very good'),
    excellent: t('l.application.view.excellent.text', 'Excellent')
  }
  const title = titles[rate]

  const randomWord = '*****'

  return (
    <Wrapper>
      <SubWrapper>
        {!isNil(value) ? (
          <>
            <Trans value={value} i18nKey="l.application.view.number_of_days.text" t={t}>
              <ValueText hasWarning={hasWarning} type="small" isLocked={isLocked} fontWeight="500">
                {{ value }} days
              </ValueText>
            </Trans>
            {isLocked ? (
              <ValueText isLocked={isLocked} fontWeight="500">
                {randomWord}
              </ValueText>
            ) : (
              <StatusBadge type={rate} size="small" title={title} />
            )}
          </>
        ) : (
          <ValueText isLocked={isLocked} fontWeight="500">
            -
          </ValueText>
        )}
      </SubWrapper>
    </Wrapper>
  )
}

export default SummaryContainer
